import { withNfe } from "@moodys/federated";
import { GlobalModals } from "components/GlobalModals";
import { SplitClientHeader } from "components/Header/SplitClientHeader";
import { SplitFactoryLayoutContext } from "components/SplitFactoryLayoutContext/SplitFactoryLayoutContext";

export const HeaderWithLayoutProvider = () => {
  return (
    <SplitFactoryLayoutContext>
      <GlobalModals />
      <SplitClientHeader />
    </SplitFactoryLayoutContext>
  );
};

export default withNfe(HeaderWithLayoutProvider);
